<div class="card">
  <div class="card-header">
    <span class="card-title">Add User</span>
  </div>

  <div class="card-body">
    <mat-form-field class="no-subscript">
      <input
        matInput
        type="text"
        placeholder="Select User"
        [matAutocomplete]="auto"
        (keyup)="filter($event)"
      />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option
          *ngFor="let user of usersFiltered"
          [value]="user.name"
          (onSelectionChange)="getUserSelected($event.source.selected, user)"
        >
          {{ user.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="card-footer">
    <div mat-dialog-actions align="center">
      <button mat-flat-button color="warn" (click)="cancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="add()">Add</button>
    </div>
  </div>
</div>
